import { EntityState, Entity } from '../../model/intent/types';
import {
  EntityActionTypes,
  FILL_ENTITIES,
  saveEntityActionType,
  deleteEntityActionType,
} from '../../model/entity/action';
import { replaceOrInsert } from '../../helpers/immutableHelper';

const initialState: EntityState = {
  entities: [],
};

export function entityReducer(
  state = initialState,
  action: EntityActionTypes,
): EntityState {
  switch (action.type) {
    case FILL_ENTITIES:
      return {
        entities: action.payload,
      };
    case saveEntityActionType.success:
      return {
        entities: replaceOrInsert<Entity>(state.entities, action.payload),
      };
    case deleteEntityActionType.success:
      return {
        entities: state.entities.filter((x) => x.id !== action.payload),
      };
    default:
      return state;
  }
}
